import React from 'react';
import { X } from 'lucide-react';

const BaseModal = ({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = '2xl',
  zIndex = 50,
  showCloseButton = true,
  closeOnBackdrop = true,
}) => {
  React.useEffect(() => {
    const handleKeyPress = e => {
      if (e.key === 'Escape' && isOpen && closeOnBackdrop) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyPress);
      return () => document.removeEventListener('keydown', handleKeyPress);
    }
  }, [isOpen, onClose, closeOnBackdrop]);

  if (!isOpen) return null;

  const handleBackdropClick = e => {
    if (e.target === e.currentTarget && closeOnBackdrop) {
      onClose();
    }
  };

  const maxWidthClass = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '4xl': 'max-w-4xl',
    '6xl': 'max-w-6xl',
  };

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4`}
      style={{ zIndex }}
      onClick={handleBackdropClick}
    >
      <div
        className={`bg-black border border-gray-600 rounded-lg p-6 w-full ${maxWidthClass[maxWidth]} max-h-[90vh] overflow-y-auto dark-scrollbar`}
      >
        {(title || showCloseButton) && (
          <div
            className={`flex items-center mb-4 ${showCloseButton ? 'justify-between' : 'justify-center'}`}
          >
            {title && <h3 className="text-xl font-bold text-white">{title}</h3>}
            {showCloseButton && (
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-red-500 p-1"
                title="Close"
              >
                <X size={24} />
              </button>
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default BaseModal;
